import moment from 'moment';

// Register locales with moment (side effects).
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/ja';

/**
 * App i18n codes (translation folders / i18next) → moment locale ids.
 */
const I18N_TO_MOMENT = {
  en: 'en',
  de: 'de',
  fr: 'fr',
  es: 'es',
  ja: 'ja'
};

/**
 * @param {string | undefined} lng — i18next language (e.g. en, de, ja)
 * @returns {string} moment locale key
 */
export function getMomentLocaleForI18n(lng) {
  if (!lng) return 'en';
  let base = String(lng).toLowerCase();
  if (base.includes('-')) {
    [base] = base.split('-');
  }
  return I18N_TO_MOMENT[base] || 'en';
}

/**
 * Align moment's global locale with the active UI language (same signal as D3 / i18n).
 */
export function applyMomentLocale(lng) {
  moment.locale(getMomentLocaleForI18n(lng));
}
